export class EditorPecaDespacho {
  conteudo: string;
  placeholders?: Map<String, String>;

  constructor() {
    this.conteudo = '';
  }

}

